module.exports = __webpack_public_path__ + "static/img/platform-icon-1.320aedd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/platform-icon-1.png
// module id = U/1o
// module chunks = 1